import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import WarningTriangle from '../components/WarningTriangle';

const RenderErrors = ({ title, errors = [] }) => {
  if (errors.length) {
    return (
      <div className="shipment-error-modal-section">
        {errors.map((error) => {
          const consignmentRef = error?.consignmentReferenceNumber;

          return (
            <>
              <b>{consignmentRef ? 'Consignment' : 'Shipment'} Errors</b> {consignmentRef && <>({consignmentRef})</>}
              <div className="shipment-error-modal-list">
                <div key={`${error.consignmentId}-${error.errorMessage}`} className="shipment-error-modal-error">
                  <div className="shipment-error-icon">
                    <WarningTriangle color="red" />
                  </div>
                  <div className="shipment-error-message">
                    <strong>{error.errorMessage}</strong>

                    {error.errorPaths.map((err) => {
                      return (
                        <div style={{ lineHeight: '15px', marginBottom: '8px' }}>
                          <small>{err.errorDetails}</small>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
    );
  }
};

const ShipmentErrorModal = ({ open, setOpen, errorData }) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        component: 'form',
        onSubmit: (event) => {
          event.preventDefault();

          setOpen(false);
        },
        sx: { minWidth: 800, maxWidth: 800 },
      }}
      maxWidth="md"
    >
      <DialogTitle>ICS2 Errors</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <p>Errors received on this shipment</p>

          <RenderErrors title="Shipment Errors" errors={errorData?.ensErrors} />

          <p>Please select the consignment to review and correct the error(s)</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShipmentErrorModal;
